import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./Settings.css";
import { GoKey } from "react-icons/go";
import { BsTerminal } from "react-icons/bs";

import { RiUserLine } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import Profile from "./Profile/Profile";
import UserAccess from "./UserAccess/UserAccess";
import Developers from "./Developers/Developers";
import Resource from "./Resources/Resource";
import Billing from "./Billing/Billing";
const settingIcon = "/assets/settingIcon.svg";

// let routes = [
//     {
//         path: '',
//         name: 'Profile',
//         icon: <RiUserLine />,
//     },
//     {
//         path: '/userAccess',
//         name: 'User Access',
//         icon: <GoKey />,
//     },
//     // {
//     //     path: '/developers',
//     //     name: 'Developers',
//     //     icon: <BsTerminal />,
//     // },
//     {
//         path: '/resourceNew',
//         name: 'Resource',
//         icon: <BsTerminal />,
//     },
//     {
//         path: '/billing',
//         name: 'Billing',
//         icon: <BsTerminal />,
//     },
// ];

const Settings = () => {
  const [routes, setRoutes] = useState([]);
  const Navigate = useNavigate();
  const userProfileData = useSelector(
    (state) => state.SettingsUserProfileData?.user_profile_data
  );

  const [selectedItem, setSelectedItem] = useState("");
  const [data, setData] = useState("Billing");
  const defaultRoutes = [
    {
      path: "",
      name: "Profile",
      icon: <RiUserLine />,
    },
    {
      path: "/userAccess",
      name: "User Access",
      icon: <GoKey />,
    },
  ];

  useEffect(() => {
    setRoutes(defaultRoutes);
  }, []);

  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    let newRoutes = [];
    newRoutes = [...defaultRoutes];
    if (userProfileData && !updated) {
      if (
        userProfileData?.subscription != "SELF_MANAGED" ||
        userProfileData?.client_id == 1
      ) {
        newRoutes = [
          ...newRoutes,
          {
            path: "/billing",
            name: "Billing",
            icon: <BsTerminal />,
          },
        ];
      }
      if (userProfileData?.client_id == 1) {
        newRoutes = [
          ...newRoutes,
          {
            path: "/resourceNew",
            name: "Resource",
            icon: <BsTerminal />,
          },
        ];
      }
      if (userProfileData?.subscription === null) {
        setSelectedItem("Billing");
      } else if (newRoutes[0] !== undefined) {
        setSelectedItem(newRoutes[0].name);
      }
      setRoutes(newRoutes);
      setUpdated(true);
    }
  }, [userProfileData]);

  const handleClick = (name) => {
    if (userProfileData?.subscription) {
      setData(name);
      setSelectedItem(name);

      //gtm
      window.dataLayer.push({
        event: name,
        buttonName: name,
        userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
        clientId: JSON.parse(localStorage.getItem("userDetails"))?.client_id,
      });
    }
  };
  return (
    <div className="setting-main">
      <div className="setting-container">
        <div className="setting-icon">
          <img src={settingIcon} alt="" /> <p>Settings</p>
        </div>
        <div className="top-option">
          {routes?.map((item, index) => (
            <Link
              style={
                !userProfileData?.subscription ? { cursor: "not-allowed" } : {}
              }
              to={
                userProfileData?.subscription
                  ? `/settings${item.path}`
                  : "/settings"
              }
              key={`settings-menu-${index}`}
              onClick={() => handleClick(item.name)}
              className={
                item.name === selectedItem
                  ? "underline-setting-item"
                  : "setting-item"
              }
            >
              {item.icon} {item.name}
            </Link>
          ))}
        </div>
      </div>
      <div className="main-setting-div">
        <div className="setting-front-page">
          {selectedItem === "User Access" ? (
            <UserAccess user_client_id={userProfileData?.client_id} />
          ) : selectedItem === "Resource" ? (
            // <Developers />
            <Resource />
          ) : selectedItem === "Billing" ? (
            <Billing />
          ) : (
            <Profile />
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
